/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
'use strict';var __importDefault=this&&this['__importDefault']||function(_0x1ba9ed){return _0x1ba9ed&&_0x1ba9ed['__esModule']?_0x1ba9ed:{'default':_0x1ba9ed};};Object['defineProperty'](exports,'__esModule',{'value':!0x0});const message_1=__importDefault(require('./../../message'));class GetUserMessage extends message_1['default']{constructor(_0xfb3f38){super(),this['id']=_0xfb3f38;}['toJSON'](){return{'id':this['id']};}static['fromJSON'](_0x53447d){return new GetUserMessage(_0x53447d['id']);}}exports['default']=GetUserMessage,GetUserMessage['TYPE']='21',GetUserMessage['READABLE_TYPE_NAME']='getUser',GetUserMessage['DESCRIPTOR_NAME']='GetUserMessage',GetUserMessage['DESCRIPTOR']={'fields':{'id':{'type':'string','id':0x1}}};